<script>
export default {
    name: 'IconLock'
}
</script>
<template>
    <svg
        class="base-icon icon-lock"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M32 8c6.075 0 11 4.925 11 11v7h8v30H13V26h8v-7c0-6.075 4.925-11 11-11zm0 26a4 4 0 00-2 7.465V48a2 2 0 104 0l.001-6.536A4 4 0 0032 34zm0-20a5 5 0 00-5 5v7h10v-7a5 5 0 00-4.783-4.995z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
